import { defaultBaseBackgroundRenderContribution } from "./base-contribution-render";

import { defaultBaseTextureRenderContribution } from "./base-texture-contribution-render";

export const defaultPathTextureRenderContribution = defaultBaseTextureRenderContribution;

export const defaultPathBackgroundRenderContribution = defaultBaseBackgroundRenderContribution;
//# sourceMappingURL=path-contribution-render.js.map
